"use client";

import { IconButton, Stack, Typography } from "@mui/material";
import { FormProvider, useFormContext, useWatch } from "react-hook-form";
import {
  ParsedValue,
  parseVariableToString,
} from "@/src/components/TextWithValue";
import { TourismOrderField } from "../lib/types";
import { isMobile } from "react-device-detect";
import { WebShopIcon } from "@/src/components/WebShopIcon";

export const TouristOrderField: React.FC<{
  item: TourismOrderField;
  name: string;
  index: number;

  handleEditClick: (args: any) => void;
}> = ({ item, name: formKey, index, handleEditClick }) => {
  const { control } = useFormContext();
  const value = useWatch({ control, name: `${formKey}.${index}` });

  const editable = !!item.modalFiedls?.length;
  return (
    <>
      <>
        <Typography className="text relative hidden text-nowrap text-dark-gray md:inline">
          <ParsedValue value={item.label || ""} />:
          {/* {!!errors?.length && (
            <div className="absolute -bottom-3 left-0 text-xs text-red">
              {errors}
            </div>
          )} */}
        </Typography>
        <div className="hidden flex-row gap-2 md:flex">
          <Stack className="flex flex-row gap-1 font-semibold text-dark-gray">
            {item.names?.map((name) => {
              return (
                <Typography
                  key={name}
                  className="text-base font-semibold text-dark-gray"
                >
                  {!!value && parseVariableToString(value[name], name)}
                </Typography>
              );
            })}
          </Stack>
          {editable && !isMobile && (
            <IconButton
              className="flex p-1"
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(item);
              }}
            >
              <WebShopIcon name="pencil" fill={"#009DDE"} />
            </IconButton>
          )}
        </div>
      </>
      <div className="flex w-full justify-between gap-6 md:hidden">
        <Stack className="relative gap-6 flex-center-row max-md:flex-col max-md:items-start max-md:gap-1">
          <Typography className="text relative text-nowrap text-dark-gray">
            <ParsedValue value={item.label || ""} />:
          </Typography>
          <Stack className="gap-1 font-semibold text-dark-gray flex-center-row max-md:justify-between">
            {item.names?.map((name) => {
              return (
                <Typography
                  key={name}
                  className="text-base font-semibold text-dark-gray"
                >
                  {!!value && parseVariableToString(value[name], name)}
                </Typography>
              );
            })}
          </Stack>
        </Stack>
        {editable && isMobile && (
          <IconButton
            className="flex p-1"
            onClick={(e) => {
              e.stopPropagation();
              handleEditClick(item);
            }}
          >
            <WebShopIcon name="pencil" fill={"#009DDE"} />
          </IconButton>
        )}
      </div>
    </>
  );
};
